var React = require('react');

function DashesInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 28H16.7172L31 0H24.2828L10 28Z","fill":"#E30613","key":0}),React.createElement("path",{"d":"M0 28H6.71717L21 0H14.2828L0 28Z","fill":"#E30613","key":1})]);
}

DashesInline.defaultProps = {"width":"31","height":"28","viewBox":"0 0 31 28","fill":"none"};

module.exports = DashesInline;

DashesInline.default = DashesInline;
